import 'styles/css/main.css';
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Footer from 'components/Footer';
import NewUser from 'components/new_user/NewUser';
import IacpUser from 'components/iacp_user/IacpUser';
import Application from 'components/Application';
import HttpClient from 'services/HttpClient';
import {inject, observer } from 'mobx-react';
import {observe} from 'mobx';
import AlertContainer from 'react-alert';
import SUCCESS_ALERT from 'styles/img/success.png';
import ERROR_ALERT from 'styles/img/error.png';
import WARN_ALERT from 'styles/img/warning.png';

@withRouter
@inject('user')
@inject('alert')
@inject("SponsorStore")
@observer
export default class AppComponent extends React.Component {

  componentWillMount = () => {
    let clientInit = new HttpClient();
    clientInit.initialize(this.props.history, this.props.user);
    this.getUrlPath();
  };


  componentDidMount = () => {
    this.historylistener(this.props.location);
    this.props.history.listen(this.historylistener);
    observe(this.props.alert, () => this.showAlert(this.props.alert.event))
  };

  componentWillUpdate = () => {
    this.props.SponsorStore.setPrevPath(this.props.location.pathname);
  }

  componentDidUpdate = () => {
    this.getUrlPath();
  }

  getUrlPath = () => {
    const pathRootName = this.props.location.pathname.split(/\//);
    this.props.SponsorStore.setSponsors(pathRootName[1]);
  }

  historylistener = (location)=>{
    window.scrollTo(0, 0);
  }

  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'light',
    time: 5000,
    transition: 'scale'
  };

  getAlertIcon = type => {
    let status;
    switch (type){
      case 'success':
        status = SUCCESS_ALERT;
        break;
      case 'error':
        status = ERROR_ALERT;
        break;
      case 'info':
        status = WARN_ALERT;
        break;
    }
    return <img src={status}/>
  };

  showAlert = data => {
    this.msg.show(data.text, {
      time: data.time || 5000,
      type: data.type,
      icon: this.getAlertIcon(data.type)
    })
  };

  render() {
    return (
      <div>
        <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
        <Switch>
          <Route path="/newuser" component={NewUser} />
          <Route path="/auth_iacp" component={IacpUser} />
          <Route path="/" component={Application}/>
        </Switch>
        <Footer/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Main.jsx